// Generated client registry. Do not edit.
import { client as authClient } from "./auth-service/client.gen";
import { client as chatClient } from "./chat-service/client.gen";

export { authClient };
export { chatClient };

export const allClients = [authClient, chatClient] as const;
